import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Upload, UserPlus, Send } from 'lucide-react';

export default function OnboardingChecklist() {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-8" data-testid="onboarding-checklist">
      <h2 className="text-xl font-bold text-gray-900 mb-2">Добро пожаловать в DataMetrics Cloud</h2>
      <p className="text-gray-600 mb-6">Пока здесь пусто — вот самый быстрый способ увидеть продукт в деле.</p>

      <div className="space-y-4">
        <button
          onClick={() => navigate('/invoices')}
          className="w-full text-left flex items-start gap-4 p-4 rounded-lg border border-blue-200 bg-blue-50 hover:bg-blue-100 transition-colors"
          data-testid="onboarding-upload-invoices"
        >
          <div className="w-9 h-9 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0">
            <Upload className="w-4.5 h-4.5 text-white" />
          </div>
          <div>
            <p className="font-medium text-gray-900">Загрузите свои счета одним файлом</p>
            <p className="text-sm text-gray-600 mt-0.5">
              Есть счета или платёжки в PDF? Загрузите их — клиенты, счета и статусы оплаты появятся сами, без ручного ввода.
            </p>
          </div>
        </button>

        <button
          onClick={() => navigate('/clients?action=new')}
          className="w-full text-left flex items-start gap-4 p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
          data-testid="onboarding-add-client"
        >
          <div className="w-9 h-9 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
            <UserPlus className="w-4.5 h-4.5 text-gray-700" />
          </div>
          <div>
            <p className="font-medium text-gray-900">Или начните вручную</p>
            <p className="text-sm text-gray-600 mt-0.5">Добавьте первого клиента и проект — если готовых счетов ещё нет.</p>
          </div>
        </button>

        <button
          onClick={() => navigate('/connectors')}
          className="w-full text-left flex items-start gap-4 p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
          data-testid="onboarding-connect-reports"
        >
          <div className="w-9 h-9 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
            <Send className="w-4.5 h-4.5 text-gray-700" />
          </div>
          <div>
            <p className="font-medium text-gray-900">Настройте отчёты</p>
            <p className="text-sm text-gray-600 mt-0.5">Подключите Telegram или Bitrix24 — сводка будет приходить сама, без захода в систему.</p>
          </div>
        </button>
      </div>
    </div>
  );
}
